import * as React from 'react';
import getHtmlDataSet from 'Utils/GetHtmlDataSet';
import postData from 'Utils/PostData';

// Assets

import '../Assets/Navbar.sass';
import { Link } from 'react-router-dom';
import ProfileButton from './ProfileButton';
import LoginButton from './LoginButton';
import { FiCheck } from "react-icons/fi";


interface INavbarProps {
    navbarClass: string;
}

// Components
export default class Navbar extends React.Component<INavbarProps, {}> {
    private getProfileButton() {
        switch (getHtmlDataSet().mode) {
            case 'I':
            case 'C':
            case 'S':
                return <ProfileButton />;
            default:
                return <LoginButton />
        }
    }

    private setUserMode(mode) {
        postData(
            '/user/switch-mode/?format=json',
            {
                new_mode: mode
            },
            'application/x-www-form-urlencoded')
            .then(() => { window.location.reload() })
            .catch(err => console.error(err));
    }

    public render() {
        //     return <React.Fragment>
        //         <nav className={'navbar navbar-default navbar-expand-md ml-auto mr-auto ' + this.props.navbarClass}>
        //             <Link to='/frontend/courseware/courseslist' className='navbar-brand orange-text'>BodhiTree</Link>
        //             <button
        //                 className='navbar-toggler'
        //                 type='button'
        //                 data-toggle='collapse'
        //                 data-target='#navbarSupportedContent'
        //                 aria-controls='navbarSupportedContent'
        //                 aria-expanded='false'
        //                 aria-label='Toggle navigation'>
        //                 <span className='navbar-toggler-icon'></span>
        //             </button>
        //             <div className='collapse navbar-collapse' id='navbarSupportedContent'>
        //                 <ul className='navbar-nav ml-auto navlinks'>
        //                     <li className='nav-item'>
        //                         <Link to='/frontend/courseware/' className='nav-link'>Courses</Link>
        //                     </li>
        //                     <li className='nav-item'>
        //                         <a className='nav-link' href='#'>Contact Us</a>
        //                     </li>
        //                     {this.getProfileButton()}
        //                 </ul>
        //             </div>
        //         </nav>
        //     </React.Fragment>;
        // }

        return (<React.Fragment>

            <nav className="bd-navbar navbar navbar-default navbar-expand-md navbar-toggleable-md fixed-top" role="navigation">
                <div className="container">
                    <div className="bd-navbar-content">
                        <div className="navbar-header">
                            <button className="navbar-toggler navbar-toggler-right" type="button"
                                data-toggle="collapse"
                                data-target="#bs-navbar-collapse-1"
                                aria-controls="bs-navbar-collapse-1"
                                aria-expanded="false"
                                aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>

                            <Link to='/frontend' className='navbar-brand bd-navbar-brand'>BodhiTree</Link>
                            {/* <a id="bodhiTreeTitle" className="navbar-brand" style="text-decoration: none !important; " href="{% url 'landing' %}">BodhiTree</a> */}
                            {/* {% if user.is_authenticated %} */}

                            <Link to="/frontend/courseware" id="exploreButtonTrigger" className="navbar-brand">Explore&nbsp; &nbsp;</Link>
                            <Link className="navbar-brand btn btn-primary exploreButton" id="bodhiMyCourse" to="/frontend/courseware/courseslist"> My Dashboard</Link>
                            {/* {% else %} */}
                            {/* <Link to="/frontend/courseware" id="exploreButtonTrigger" className="navbar-brand">Explore</Link> */}
                            {/* {% endif%} */}
                        </div>
                    </div>

                    <div className="collapse navbar-collapse" id="bs-navbar-collapse-1">
                        <ul className="nav navbar-nav navbar-right">
                            <li className='nav-item'>
                                <a className='nav-link' href='https://bit.ly/bodhi-manual'>User Manual</a>
                            </li>
                            <li className='nav-item dropdown'>
                                <a className='nav-link dropdown-toggle'
                                    href='#'
                                    id="modeDropDown"
                                    role='button'
                                    data-toggle='dropdown'
                                    aria-haspopup='true'
                                    aria-expanded='false'>
                                    Role: {getHtmlDataSet().mode == "I" ? "Instructor" : "Student"}
                                </a>
                                <div className='dropdown-menu' aria-labelledby='modeDropDown'>
                                    <a className='dropdown-item' href='#' onClick={() => this.setUserMode('S')}>Student {getHtmlDataSet().mode == "S" && <FiCheck size={20} />}</a>
                                    <div className='dropdown-divider'></div>
                                    <a className='dropdown-item' href='#' onClick={() => this.setUserMode('I')}>Instructor {getHtmlDataSet().mode == "I" && <FiCheck size={20} />}</a>
                                </div>
                            </li>
                            {this.getProfileButton()}
                        </ul>

                    </div>
                </div>
            </nav>
        </React.Fragment>)
    }
};
